import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Input {
  id: string;
  name: string;
  description?: string;
  quantity: number;
  unit: string;
  created_at: string;
}

interface InputsState {
  byId: Record<string, Input>;
  allIds: string[];
  isLoading: boolean;
  error: string | null;
}

const initialState: InputsState = {
  byId: {},
  allIds: [],
  isLoading: false,
  error: null,
};

const inputsSlice = createSlice({
  name: 'inputs',
  initialState,
  reducers: {
    setInputs: (state, action: PayloadAction<Input[]>) => {
      state.byId = {};
      state.allIds = [];
      action.payload.forEach((input) => {
        state.byId[input.id] = input;
        state.allIds.push(input.id);
      });
    },
    addInput: (state, action: PayloadAction<Input>) => {
      const input = action.payload;
      state.byId[input.id] = input;
      if (!state.allIds.includes(input.id)) {
        state.allIds.push(input.id);
      }
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const { setInputs, addInput, setLoading, setError } = inputsSlice.actions;

export default inputsSlice.reducer;
